import HTTP from './axios';

const PatientSchedulesService = {
  get: (patientId, scheduleId) => HTTP.get(`/patients/${patientId}/schedules/${scheduleId}`)
    .then(response => response.data.data),

  getNexts: patientId => HTTP.get(`/patients/${patientId}/schedules/nexts`)
    .then(response => response.data.data),

  getStatistics: patientId => HTTP.get(`/patients/${patientId}/schedules/statistics`)
    .then(response => response.data.data),

  getByStatus: (patientId, status) => HTTP.post(`/patients/${patientId}/schedules/status`, { status })
    .then(response => response.data.data),

  schedule: (id, scheduleId, patientId, covenantId, specialityId) => HTTP.post(`/calendars/${id}/schedule`, {
    scheduleId, patientId, covenantId, specialityId,
  }).then(response => response.data.data),

  saveReminder: (patientId, parameters) => HTTP.post(`/patients/${patientId}/schedules/reminder`, parameters)
    .then(response => response.data.data),

  cancel: (patientId, scheduleId) => HTTP.put(`/patients/${patientId}/schedules/${scheduleId}/cancel`, { patientId, scheduleId })
    .then(response => response.data.data),
};

export default PatientSchedulesService;
